const styles = theme => ({
  root: {

  },
  interactions: {
    textAlign: 'center',
  },
  items: {
    marginTop: 10,
    alignItems: 'center',
    marginLeft: '0',
    [theme.breakpoints.up('sm')]: {
        marginTop: 10,
        marginLeft: 'calc( (100% - 480px) * 0.5)',
    },
    [theme.breakpoints.up('md')]: {
        marginTop: 10,
        marginLeft: 'calc( (100% - 480px) * 0.5)',
    },
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Search/scenes/SavedSearches/scenes/Results/styles.js